var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentMaestro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.348,
    height: 16,
    viewBox: "0 0 24.348 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fill: "none",
    d: "M0-21.608A1.4 1.4 0 0 1 1.4-23h21.551a1.4 1.4 0 0 1 1.4 1.392v13.216A1.4 1.4 0 0 1 22.951-7H1.4A1.4 1.4 0 0 1 0-8.392z",
    clipRule: "evenodd",
    transform: "translate(0 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M12.7-3.716v-.793a.469.469 0 0 0-.135-.363.469.469 0 0 0-.361-.138.489.489 0 0 0-.444.225.464.464 0 0 0-.418-.225.418.418 0 0 0-.37.188v-.156H10.7v1.263h.278v-.7a.3.3 0 0 1 .075-.241.3.3 0 0 1 .234-.095c.182 0 .275.119.275.333v.7h.278v-.7a.3.3 0 0 1 .076-.24.3.3 0 0 1 .233-.1c.188 0 .278.119.278.333v.7zm1.547-.631v-.631h-.278v.153a.479.479 0 0 0-.4-.185.661.661 0 0 0-.661.661.661.661 0 0 0 .661.661.479.479 0 0 0 .4-.185v.153h.275zm-1.022 0a.382.382 0 0 1 .4-.359.382.382 0 0 1 .368.388.382.382 0 0 1-.38.376.378.378 0 0 1-.282-.117.378.378 0 0 1-.1-.288zm6.9-.661a.711.711 0 0 1 .264.05.661.661 0 0 1 .216.14.64.64 0 0 1 .143.21.7.7 0 0 1 0 .529.639.639 0 0 1-.143.21.661.661 0 0 1-.216.14.748.748 0 0 1-.542 0 .653.653 0 0 1-.214-.14.645.645 0 0 1-.141-.21.7.7 0 0 1 0-.529.645.645 0 0 1 .141-.21.653.653 0 0 1 .214-.14.712.712 0 0 1 .275-.054zm0 .264a.41.41 0 0 0-.157.029.371.371 0 0 0-.126.083.387.387 0 0 0-.083.132.459.459 0 0 0 0 .328.386.386 0 0 0 .083.132.37.37 0 0 0 .126.083.43.43 0 0 0 .313 0 .378.378 0 0 0 .132-.083.383.383 0 0 0 .083-.132.459.459 0 0 0 0-.328.383.383 0 0 0-.083-.132.378.378 0 0 0-.132-.083.41.41 0 0 0-.159-.037zm-4.382.4a.6.6 0 0 0-.6-.661.661.661 0 0 0-.652.67.661.661 0 0 0 .67.652.767.767 0 0 0 .517-.177l-.132-.2a.6.6 0 0 1-.368.132.35.35 0 0 1-.378-.309h.938a.862.862 0 0 0 .005-.11zm-.94-.111a.325.325 0 0 1 .332-.305.313.313 0 0 1 .224.087.313.313 0 0 1 .1.22zm2.1-.2a.813.813 0 0 0-.4-.108c-.151 0-.241.056-.241.148s.1.108.214.124l.132.019c.275.04.442.156.442.378s-.212.413-.575.413a.911.911 0 0 1-.546-.164l.132-.214a.673.673 0 0 0 .42.132c.188 0 .288-.056.288-.153 0-.071-.071-.111-.222-.132l-.132-.019c-.283-.04-.436-.167-.436-.373 0-.251.206-.4.529-.4a.944.944 0 0 1 .514.132zm1.322-.071h-.448v.57c0 .132.045.212.182.212a.508.508 0 0 0 .243-.071l.079.235a.645.645 0 0 1-.344.1c-.325 0-.439-.175-.439-.468v-.575h-.258v-.251h.26v-.383h.278v.383h.448zm.951-.283a.587.587 0 0 1 .2.034l-.085.264a.447.447 0 0 0-.172-.032c-.18 0-.264.116-.264.325v.707h-.275v-1.262h.272v.153a.373.373 0 0 1 .333-.185zm1.9 1.111a.132.132 0 0 1 .05.009.132.132 0 0 1 .041.026.132.132 0 0 1 .028.04.123.123 0 0 1 0 .1.132.132 0 0 1-.028.04.132.132 0 0 1-.041.026.124.124 0 0 1-.05.011.132.132 0 0 1-.119-.077.124.124 0 0 1 0-.1.132.132 0 0 1 .028-.04.132.132 0 0 1 .041-.026.132.132 0 0 1 .044-.009zm0 .223a.094.094 0 0 0 .038-.008.1.1 0 0 0 .03-.021.1.1 0 0 0 .027-.087.1.1 0 0 0-.057-.071.1.1 0 0 0-.038-.008.1.1 0 0 0-.038.008.1.1 0 0 0-.038.019.1.1 0 0 0 0 .132.1.1 0 0 0 .07.029zm.008-.157a.053.053 0 0 1 .034.011.033.033 0 0 1 .012.028.032.032 0 0 1-.009.024.046.046 0 0 1-.028.012l.038.044H21.1l-.036-.044h-.012v.044h-.025v-.122zm-.029.022v.032h.029a.028.028 0 0 0 .016 0 .013.013 0 0 0 0-.012.013.013 0 0 0 0-.012.028.028 0 0 0-.016 0z",
    className: "cls-2",
    transform: "translate(-10.699 5.362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M14.956-18.66h4.165v7.486h-4.165z",
    className: "cls-2",
    transform: "translate(-14.956 18.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M12.762-15.362a4.752 4.752 0 0 1 1.818-3.743 4.76 4.76 0 0 0-6.439.513 4.76 4.76 0 0 0 0 6.459 4.76 4.76 0 0 0 6.439.513 4.752 4.752 0 0 1-1.818-3.742z",
    className: "cls-2",
    transform: "translate(-6.879 20.123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M28.4-8.63v-.541h.1v-.116h-.273v.116h.108v.56zm.53 0v-.676h-.083l-.1.483-.1-.483h-.085v.676h.06v-.507l.09.44h.062l.09-.44v.512z",
    className: "cls-2",
    transform: "translate(-28.232 9.306)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M25.651-15.362a4.76 4.76 0 0 1-2.68 4.28 4.76 4.76 0 0 1-5.021-.538 4.76 4.76 0 0 0 1.819-3.743 4.76 4.76 0 0 0-1.819-3.743 4.76 4.76 0 0 1 5.022-.539 4.76 4.76 0 0 1 2.68 4.282z",
    className: "cls-2",
    transform: "translate(-17.95 20.124)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none}.cls-11{fill:#00a0de}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Payment-Maestro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M-5-28h31.3v22.957H-5z",
    transform: "translate(1.522 24.522)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    clipPath: "url(#clip-path-2)",
    transform: "translate(7.442 12.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fill: "#fff",
    d: "M5.7-10.362h17.46v8.669H5.7z",
    transform: "translate(-9.177 6.884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    clipPath: "url(#clip-path-3)",
    transform: "translate(10.404 3.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fill: "#7673c0",
    d: "M9.956-23.66h11.122v14.442H9.956z",
    transform: "translate(-13.435 20.182)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    clipPath: "url(#clip-path-4)",
    transform: "translate(4.785 2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fill: "#ea001b",
    d: "M1.879-25.123h14.658v16.477H1.879z",
    transform: "translate(-5.357 21.645)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    clipPath: "url(#clip-path-5)",
    transform: "translate(19.639 9.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M23.232-14.306h7.652v7.652h-7.652z",
    className: "cls-11",
    transform: "translate(-26.71 10.828)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    clipPath: "url(#clip-path-6)",
    transform: "translate(12.487 2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M12.95-25.124h14.659v16.477H12.95z",
    className: "cls-11",
    transform: "translate(-16.428 21.646)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentMaestro);
export default __webpack_public_path__ + "static/media/logo-payment-maestro.09243051.svg";
export { ForwardRef as ReactComponent };